import { Stack, Skeleton } from '@mui/material';
import React from 'react';
const CandidateFeedbackDetailHeaderShimmer = () => {
  return (
    <Stack
      id='feedback-detail-header-shimmer'
      data-testid='feedback-detail-header-shimmer'
      direction='row'
      justifyContent='space-between'
      sx={{
        height: '2.75rem',
        width: '100%',
      }}
    >
      <Stack>
        <Skeleton
          data-testid='skeleton-1'
          variant='rectangular'
          width={254}
          height={24}
          sx={{
            bgcolor: (theme) => theme.palette.neutral?.main,
          }}
        />
        <Skeleton
          data-testid='skeleton-2'
          variant='rectangular'
          width={209}
          height={20}
          sx={{
            bgcolor: (theme) => theme.palette.neutral?.main,
          }}
        />
      </Stack>
      <Skeleton
        data-testid='skeleton-2'
        variant='rectangular'
        width={136}
        height={32}
        sx={{
          bgcolor: (theme) => theme.palette.neutral?.main,
        }}
      />
    </Stack>
  );
};

export default CandidateFeedbackDetailHeaderShimmer;
